import React from "react";
import Sparkline from "@/components/admin/Sparkline";

export default function StatCard({ label, value, subtext, icon: Icon, colorClass = "text-gold-600", sparkData }) {
  return (
    <div className="rounded-2xl border border-border bg-white p-5 card-shadow">
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        {Icon && <Icon size={20} className={colorClass} />}
      </div>
      <div className="mt-2 flex items-end justify-between gap-2">
        <p className="font-head text-2xl font-bold text-navy">{value}</p>
        {sparkData && sparkData.length > 1 && <Sparkline data={sparkData} />}
      </div>
      {subtext && <p className="mt-1 text-xs text-muted-foreground">{subtext}</p>}
    </div>
  );
}
